import React from "react";
import { Pencil, Save } from "lucide-react";

const FIELDS = [
  { key: "name", label: "Full Name" },
  { key: "headline", label: "Professional Headline" },
  { key: "current_role", label: "Current Role" },
  { key: "current_org", label: "Organization" },
  { key: "location", label: "Location" },
  { key: "years_experience", label: "Years of Experience", type: "number" },
];

export const ProfileTab = ({ profile, profileForm, setProfileForm, editing, setEditing, onSave, saving }) => (
  <div className="card-flat">
    <div className="flex items-center justify-between mb-6">
      <h3 className="text-lg font-medium text-[#0F172A]" style={{ fontFamily: "'Playfair Display', serif" }}>Professional Profile</h3>
      <button onClick={() => setEditing(!editing)} className="flex items-center gap-2 text-sm btn-secondary">
        <Pencil size={13} /> {editing ? "Cancel" : "Edit"}
      </button>
    </div>
    {editing ? (
      <div className="grid md:grid-cols-2 gap-4">
        {FIELDS.map(({ key, label, type }) => (
          <div key={key}>
            <label className="text-xs font-semibold text-[#0F172A] uppercase tracking-wider block mb-1">{label}</label>
            <input type={type || "text"} value={profileForm[key] || ""} onChange={e => setProfileForm(f => ({ ...f, [key]: type === "number" ? parseInt(e.target.value) : e.target.value }))}
              className="w-full border border-[#E4E4E1] text-sm px-3 py-2 rounded-sm focus:outline-none focus:border-[#0F172A]" />
          </div>
        ))}
        <div className="md:col-span-2">
          <label className="text-xs font-semibold text-[#0F172A] uppercase tracking-wider block mb-1">Bio</label>
          <textarea rows={4} value={profileForm.bio || ""} onChange={e => setProfileForm(f => ({ ...f, bio: e.target.value }))}
            className="w-full border border-[#E4E4E1] text-sm px-3 py-2 rounded-sm focus:outline-none focus:border-[#0F172A] resize-none" />
        </div>
        <div className="md:col-span-2 flex gap-3">
          <button onClick={onSave} disabled={saving} className="btn-primary text-sm flex items-center gap-2" data-testid="save-profile-btn">
            <Save size={14} /> {saving ? "Saving..." : "Save Profile"}
          </button>
        </div>
      </div>
    ) : (
      <div className="grid md:grid-cols-2 gap-y-4 gap-x-8 text-sm">
        {[
          { label: "Name", value: profile?.name },
          { label: "Headline", value: profile?.headline },
          { label: "Role", value: profile?.current_role },
          { label: "Organization", value: profile?.current_org },
          { label: "Location", value: profile?.location },
          { label: "Experience", value: profile?.years_experience ? `${profile.years_experience} years` : null },
        ].map(({ label, value }) => value ? (
          <div key={label}>
            <p className="text-xs text-[#A1A1AA] mb-0.5">{label}</p>
            <p className="text-[#0F172A] font-medium">{value}</p>
          </div>
        ) : null)}
        {profile?.bio && (
          <div className="md:col-span-2">
            <p className="text-xs text-[#A1A1AA] mb-0.5">Bio</p>
            <p className="text-[#52525B] leading-relaxed">{profile.bio}</p>
          </div>
        )}
      </div>
    )}
  </div>
);
